<template>
	<div class="">
		<base-page-heading
			title="Pickup stores"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="pickupstoreShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<PickupStoresTable @routePickup="routePickup" />
		</div>
	</div>
</template>
